import { stdCouleurBleu, stdCouleurRougeClair } from '@commonStyle';
import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  sidebar: {
    width: 240,
    backgroundColor: '#ffffff',
    borderRightWidth: 1,
    borderRightColor: '#e2e8f0',
    paddingTop: 16,
    paddingHorizontal: 16,
  },

  menuItemTextDisabled: {
    color: '#9ca3af',
  },

  menuItemTextActive: {
    color: '#0ea5e9',
    fontWeight: '600',
  },

  menuItemText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#64748b',
  },

  menuItemDisabled: {
    backgroundColor: '#f8fafc',
    opacity: 0.5,
  },

  menuItemActive: {
    backgroundColor: '#f0f9ff',
    borderWidth: 1,
    borderColor: '#bae6fd',
  },

  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 8,
    gap: 12,
  },

  menuProfileContainer: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 4,
    padding: 5,
    borderRadius: 5,
    backgroundColor: 'white',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 10,
    zIndex: 9999,
    minWidth: 200,
  },

  menuProfileItem: {
    width: '100%',
    padding: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 20,
  },
  
  menuProfileText: {
    fontSize: 21,
    color: stdCouleurBleu,
  },

  // Styles pour les onglets (écrans non-responsives)
  tabBar: {
  flexDirection: 'row',
  backgroundColor: '#f8f9fa',
  borderTopWidth: 1,
  borderTopColor: '#e9ecef',
  position: 'absolute',
},

  tabLink: {
    flex: 1,
    textDecorationLine: 'none',
  } as any,

  tab: {
    paddingVertical: 5,   
    alignItems: 'center',
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    height: '100%',
    verticalAlign: 'middle',
    justifyContent: 'center',
  },

  activeTab: {
    borderBottomColor:  stdCouleurRougeClair,
  },

  tabText: {
    fontSize: 12,
    color: stdCouleurBleu,
    fontWeight: '500',
    textAlign: 'center',
  },

  activeTabText: {
    color: stdCouleurRougeClair,
    fontWeight: '800',
  },
})